import 'vue';
import './helpers.mjs';
import './config.mjs';
import { b as registerComponent } from './plugins-ba5e2464.mjs';
import './Icon-a7b85e86.mjs';
import './FormElementMixin-29581863.mjs';
import './Input-19e906a1.mjs';
import { s as script } from './Autocomplete-a23ad844.mjs';
export { s as OAutocomplete } from './Autocomplete-a23ad844.mjs';

var index = {
    install(app) {
        registerComponent(app, script);
    }
};

export default index;
